import {TemplateVersion} from 'notebook/entry-templates/TemplateConstants';
import DocumentEvaluationUpdater from 'notebook/mediocre/DocumentEvaluationUpdater';
import {DocumentMapper, DocumentTraverser} from 'notebook/mediocre/DocumentTraversal';
import {WorkflowEntryTemplate} from 'workflows/entry-templates/WorkflowEntryTemplateUtil';

export default class WorkflowEntryTemplateUpdater extends DocumentEvaluationUpdater<
  WorkflowEntryTemplate,
  TemplateVersion
> {
  getDoc(item: WorkflowEntryTemplate): TemplateVersion {
    return item.templateVersion;
  }

  traverse(evalTraverser: DocumentTraverser, newDoc: TemplateVersion, oldDoc: TemplateVersion | null): void {
    evalTraverser.walkTemplateVersion(newDoc, oldDoc);
  }

  mapDoc(mapper: DocumentMapper, doc: TemplateVersion): TemplateVersion {
    return mapper.mapTemplateVersion(doc, null);
  }

  updatedRoot(root: WorkflowEntryTemplate, doc: TemplateVersion): WorkflowEntryTemplate {
    return {...root, templateVersion: doc};
  }
}
